import React from 'react'
import { Link } from 'react-router-dom';
import Teamimage01 from '../../../assets/images/blog/blog-grid-image-1.jpg';
import Teamimage02 from '../../../assets/images/blog/blog-grid-image-2.jpg';
import Teamimage03 from '../../../assets/images/blog/blog-grid-image-3.jpg';
import Teamimage04 from '../../../assets/images/blog/blog-grid-image-4.jpg';
import Teamimage05 from '../../../assets/images/blog/blog-grid-image-5.jpg';
import Teamimage06 from '../../../assets/images/blog/blog-grid-image-6.jpg';
import Teamimage07 from '../../../assets/images/blog/blog-grid-image-7.jpg';
import Teamimage08 from '../../../assets/images/blog/blog-grid-image-8.jpg';

const Teamdetail = () => {
    return (
        <div className="blog-list-section">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 col-md-12">
                        <div className="blog-block">
                            <div className="blog-list-item">
                                <div className="blog-image">
                                    <Link to="/Blogdetails">
                                        <img
                                            src={Teamimage01}
                                            alt="blog-image"
                                        />
                                    </Link>
                                </div>
                                <div className="blog-item-meta">
                                    <p>
                                        <Link to="#">By Deni</Link>
                                    </p>
                                    <p>
                                        <Link to="#">On 06 Sup 2024</Link>
                                    </p>
                                </div>
                                <div className="blog-item-details">
                                    <h3>
                                        <Link to="/Blogdetails">
                                            Unlocking Small Business Potential: Top Loan Options for
                                            Investor
                                        </Link>
                                    </h3>
                                    <Link to="/Blogdetails" className="btn-link">
                                        <span>continue reading</span> <i className="flaticon-next" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-12">
                        <div className="blog-block">
                            <div className="blog-list-item">
                                <div className="blog-image">
                                    <Link to="/Blogdetails">
                                        <img
                                            src={Teamimage02}
                                            alt="blog-image"
                                        />
                                    </Link>
                                </div>
                                <div className="blog-item-meta">
                                    <p>
                                        <Link to="#">By Elei</Link>
                                    </p>
                                    <p>
                                        <Link to="#">On 15 Aug 2024</Link>
                                    </p>
                                </div>
                                <div className="blog-item-details">
                                    <h3>
                                        <Link to="/Blogdetails">
                                            Understanding Loan Options: Which Type Fits Your Needs Best?
                                        </Link>
                                    </h3>
                                    <Link to="/Blogdetails" className="btn-link">
                                        <span>continue reading</span> <i className="flaticon-next" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-12">
                        <div className="blog-block">
                            <div className="blog-list-item">
                                <div className="blog-image">
                                    <Link to="/Blogdetails">
                                        <img
                                            src={Teamimage03}
                                            alt="blog-image"
                                        />
                                    </Link>
                                </div>
                                <div className="blog-item-meta">
                                    <p>
                                        <Link to="#">By Jhon</Link>
                                    </p>
                                    <p>
                                        <Link to="#">On 20 Jun 2024</Link>
                                    </p>
                                </div>
                                <div className="blog-item-details">
                                    <h3>
                                        <Link to="/Blogdetails">
                                            Benefits of Flexible Repayment Plans for Small Business Owners
                                        </Link>
                                    </h3>
                                    <Link to="/Blogdetails" className="btn-link">
                                        <span>continue reading</span> <i className="flaticon-next" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-12">
                        <div className="blog-block">
                            <div className="blog-list-item">
                                <div className="blog-image">
                                    <Link to="/Blogdetails">
                                        <img
                                            src={Teamimage04}
                                            alt="blog-image"
                                        />
                                    </Link>
                                </div>
                                <div className="blog-item-meta">
                                    <p>
                                        <Link to="#">By Martin</Link>
                                    </p>
                                    <p>
                                        <Link to="#">On 10 May 2024</Link>
                                    </p>
                                </div>
                                <div className="blog-item-details">
                                    <h3>
                                        <Link to="/Blogdetails">
                                            How to Loanlift for Your Startup's Growth Plans to loan
                                        </Link>
                                    </h3>
                                    <Link to="/Blogdetails" className="btn-link">
                                        <span>continue reading</span> <i className="flaticon-next" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-12">
                        <div className="blog-block">
                            <div className="blog-list-item">
                                <div className="blog-image">
                                    <Link to="/Blogdetails">
                                        <img
                                            src={Teamimage05}
                                            alt="blog-image"
                                        />
                                    </Link>
                                </div>
                                <div className="blog-item-meta">
                                    <p>
                                        <Link to="#">By Chris</Link>
                                    </p>
                                    <p>
                                        <Link to="#">On 29 Sup 2024</Link>
                                    </p>
                                </div>
                                <div className="blog-item-details">
                                    <h3>
                                        <Link to="/Blogdetails">
                                            Smart Borrowing: Tips for Managing Your Business Loan
                                        </Link>
                                    </h3>
                                    <Link to="/Blogdetails" className="btn-link">
                                        <span>continue reading</span> <i className="flaticon-next" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-12">
                        <div className="blog-block">
                            <div className="blog-list-item">
                                <div className="blog-image">
                                    <Link to="/Blogdetails">
                                        <img
                                            src={Teamimage06}
                                            alt="blog-image"
                                        />
                                    </Link>
                                </div>
                                <div className="blog-item-meta">
                                    <p>
                                        <Link to="#">By Deni</Link>
                                    </p>
                                    <p>
                                        <Link to="#">On 25 Dec 2024</Link>
                                    </p>
                                </div>
                                <div className="blog-item-details">
                                    <h3>
                                        <Link to="/Blogdetails">
                                            Improving Credit Scores: Essential Steps Before Applying Loans
                                        </Link>
                                    </h3>
                                    <Link to="/Blogdetails" className="btn-link">
                                        <span>continue reading</span> <i className="flaticon-next" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-12">
                        <div className="blog-block">
                            <div className="blog-list-item">
                                <div className="blog-image">
                                    <Link to="/Blogdetails">
                                        <img
                                            src={Teamimage07}
                                            alt="blog-image"
                                        />
                                    </Link>
                                </div>
                                <div className="blog-item-meta">
                                    <p>
                                        <Link to="#">By Juhi</Link>
                                    </p>
                                    <p>
                                        <Link to="#">On 05 Jan 2024</Link>
                                    </p>
                                </div>
                                <div className="blog-item-details">
                                    <h3>
                                        <Link to="/Blogdetails">
                                            Understanding Loan Terms: A Guide for Small Business Owners
                                        </Link>
                                    </h3>
                                    <Link to="/Blogdetails" className="btn-link">
                                        <span>continue reading</span> <i className="flaticon-next" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-12">
                        <div className="blog-block">
                            <div className="blog-list-item">
                                <div className="blog-image">
                                    <Link to="/Blogdetails">
                                        <img
                                            src={Teamimage08}
                                            alt="blog-image"
                                        />
                                    </Link>
                                </div>
                                <div className="blog-item-meta">
                                    <p>
                                        <Link to="#">By Vicky</Link>
                                    </p>
                                    <p>
                                        <Link to="#">On 29 Sup 2024</Link>
                                    </p>
                                </div>
                                <div className="blog-item-details">
                                    <h3>
                                        <Link to="/Blogdetails">
                                            Unlocking Your Path to Financial Freedom with Loanlift
                                        </Link>
                                    </h3>
                                    <Link to="/Blogdetails" className="btn-link">
                                        <span>continue reading</span> <i className="flaticon-next" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="blog-block">
                        <ul className="pagination">
                            <li className="active">
                                <Link to="#">1</Link>
                            </li>
                            <li>
                                <Link to="#">2</Link>
                            </li>
                            <li>
                                <Link to="#">3</Link>
                            </li>
                            <li>
                                <Link to="#">4</Link>
                            </li>
                            <li>
                                <Link to="#">
                                    <i className="fa-solid fa-angles-right" />
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

    )
}
export default Teamdetail;